import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { DateTime } from 'luxon';
import { debounceTime, distinctUntilChanged, filter, map, merge, Observable, OperatorFunction, Subject } from 'rxjs';
import { TripDetail } from 'src/app/api/commonInterfaces';
import { IncidentsService } from 'src/app/api/incidents.service';


export enum OnTripLinkValues {
  Dismissed = "dismissed",
  LinkSuccess = "linkSuccess",
  LinkError = "linkError"
}

export enum LinkModes {
  Link = "link",
  Unlink = "unlink"
}

@Component({
    selector: 'app-link-trip',
    templateUrl: './link-trip.component.html',
    styleUrls: ['./link-trip.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkTripComponent implements OnInit {

  private _trips: TripDetail[] = [];
  @Input() set trips(value: TripDetail[]) {

    if (value) {
      const today = DateTime.now().startOf('day').toJSDate()
      this._trips = value.sort((a, b) => {

        let aDate = DateTime.fromJSDate(a.tripDate)
        let bDate = DateTime.fromJSDate(b.tripDate)

        if (a.tripDate > today) {
          aDate = aDate.minus({ years: 100 })
        }

        if (b.tripDate > today) {
          bDate = bDate.minus({ years: 100 })
        }

        if (aDate < bDate) {
          return 1;
        }

        if (aDate > bDate) {
          return -1;
        }

        return 0;
      })
    }
  }

  get trips(): TripDetail[] {
    return this._trips;
  }

  @Input() incidentId: number = -1;

  @Input() showActionButtons: boolean = true;

  @Input() linkMode: LinkModes = LinkModes.Link;

  @Output() onLink = new EventEmitter<OnTripLinkValues>();




  form = this.fb.group({
    trip: ['']
  })

  constructor(
    private incidentService: IncidentsService,
    private fb: UntypedFormBuilder
  ) { }


  ngOnInit(): void {
  }

  linkTrip() {

    const tripId = this.form.value.trip.id;

    this.incidentService.linkTrip(this.incidentId, tripId).subscribe({
      next: () => {
        this.onLink.emit(OnTripLinkValues.LinkSuccess);
      },
      error: () => {
        this.onLink.emit(OnTripLinkValues.LinkError);
      }
    })
  }

  unlinkTrip() {

    const tripId = this.form.value.trip.id;

    this.incidentService.unlinkTrip(this.incidentId, tripId).subscribe({
      next: () => {
        this.onLink.emit(OnTripLinkValues.LinkSuccess);
      },
      error: () => {
        this.onLink.emit(OnTripLinkValues.LinkError);
      }
    })
  }

}
